import { endpoints, request } from '!core/api';

export const trlSearchInputServices = {
  wsbGetInstrumentQuotes: ({ symbol, exchange, securityType }) =>
    request.get(
      endpoints.chnn(
        `wsbGetInstrumentQuotes?symbol=${symbol}&exchange=${exchange}&securityType=${securityType}`,
      ),
    ),
};
